import EmailVerificationSuccess from "./EmailVerificationSuccess";

export default EmailVerificationSuccess;
